import type { ICancelIcon } from './helpers';

export const CancelIcon = ({ variant, ...rest }: ICancelIcon) => {
	if (variant === 'dropdown' || variant === 'danger')
		return (
			<svg
				xmlns='http://www.w3.org/2000/svg'
				viewBox='0 0 20 20'
				fill={variant === 'danger' ? 'var(--color-error-300)' : 'var(--color-primary-500)'}
				width='20'
				height='20'
				data-testid='cancel-icon'
				{...rest}
			>
				<circle
					cx='10'
					cy='10'
					r='9'
					fill={variant === 'danger' ? 'var(--color-error-300)' : 'var(--color-primary-500)'}
					width='20'
					height='20'
					style={{ opacity: variant === 'danger' ? 0.7 : 1 }}
				/>
				<path
					d='M7 7L13 13M13 7L7 13'
					stroke='var(--color-neutral-50)'
					strokeWidth='1.5'
					strokeLinecap='round'
					fill='var(--color-primary-500)'
				/>
			</svg>
		);

	return (
		<svg
			width='25'
			height='24'
			viewBox='0 0 25 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			{...rest}
		>
			<rect
				x='5.5'
				y='17.728'
				width='18'
				height='2'
				rx='1'
				transform='rotate(-45 5.5 17.728)'
				fill='white'
			/>
			<rect
				x='18.5'
				y='19'
				width='18'
				height='2'
				rx='1'
				transform='rotate(-135 18.5 19)'
				fill='white'
			/>
		</svg>
	);
};
